const KEY = 'pinweeloSignup'
const PAY_KEY = 'pinweeloNeedPay'

export const getSignupDraft = () => {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || 'null') || {}
  } catch (err) {
    return {}
  }
}

export const markNeedsPayment = () => {
  sessionStorage.setItem(PAY_KEY, '1')
}

export const needsPayment = () => sessionStorage.getItem(PAY_KEY) === '1'

export const clearNeedsPayment = () => {
  sessionStorage.removeItem(PAY_KEY)
}

export const setSignupDraft = (partial) => {
  const next = { ...getSignupDraft(), ...partial }
  sessionStorage.setItem(KEY, JSON.stringify(next))
  return next
}

export const clearSignupDraft = () => {
  sessionStorage.removeItem(KEY)
}
